// extracted by css-extract-rspack-plugin
export default {"card":"l05XA","chartArea":"FuTCH","visualization":"Dc_IK","autoLoadTrigger":"cmqt8","skeletonCard":"kP0pn"};